import { createSlice } from "@reduxjs/toolkit";
import { DepartmentResponse, FacultyResponse } from "../../models/dtos";
import { RootState } from "../../store";

const initialState = {
    filters: {
        faculties: [] as FacultyResponse[],
        departments: [] as DepartmentResponse[],
    }
};

const teachersSlice = createSlice({
    name: "teachers",
    initialState,
    reducers: {
        setSelectedFaculties: (state, action) => {
            state.filters.faculties = action.payload;
        },
        setSelectedDepartments: (state, action) => {
            state.filters.departments = action.payload;
        },
        clearTeachersFilters: (state) => {
            state.filters = initialState.filters;
        }
    }
});

export const { setSelectedDepartments, setSelectedFaculties, clearTeachersFilters } = teachersSlice.actions;
export const getDepartmentsFilters = (state: RootState) => state.teachers.filters;
export const getFacultiesFilters = (state: RootState) => state.teachers.filters.faculties;
export const getSelectedDepartments = (state: RootState) => state.teachers.filters.departments;
export const getSelectedFaculties = (state: RootState) => state.teachers.filters.faculties;
export const getTeachersFiltersCount = (state: RootState) => {
    return state.teachers.filters.departments.length + state.teachers.filters.faculties.length;
}

export default teachersSlice.reducer;